/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthResponse
 */
export interface OAuthResponse {
    /**
     * 
     * @type {string}
     * @memberof OAuthResponse
     */
    tokenType?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthResponse
     */
    expiresIn?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthResponse
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthResponse
     */
    refreshToken?: string;
}

export function OAuthResponseFromJSON(json: any): OAuthResponse {
    return OAuthResponseFromJSONTyped(json, false);
}

export function OAuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenType': !exists(json, 'token_type') ? undefined : json['token_type'],
        'expiresIn': !exists(json, 'expires_in') ? undefined : json['expires_in'],
        'accessToken': !exists(json, 'access_token') ? undefined : json['access_token'],
        'refreshToken': !exists(json, 'refresh_token') ? undefined : json['refresh_token'],
    };
}

export function OAuthResponseToJSON(value?: OAuthResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token_type': value.tokenType,
        'expires_in': value.expiresIn,
        'access_token': value.accessToken,
        'refresh_token': value.refreshToken,
    };
}

